"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _AppsList = _interopRequireDefault(require("./AppsList"));

var _AppsGrid = _interopRequireDefault(require("./AppsGrid"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    width: "100%",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  search: {
    display: "flex",
    position: "relative",
    backgroundColor: "transparent",
    color: "black",
    height: "36px",
    overflow: "hidden",
    fontFamily: "Akkurat, sans-serif",
    margin: "12px"
  },
  scroller: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  results: {
    marginTop: theme.spacing(7),
    display: "flex",
    width: "100%",
    flexWrap: "wrap"
  },
  nohits: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    padding: theme.spacing(1.5)
  }
}));

const FilterAppsUncontrolled = ({
  className,
  search,
  q,
  apps = [],
  layout = "list",
  onSearch,
  onSelect
}) => {
  const classes = useStyles();

  if (!apps.length) {
    return _react.default.createElement("div", {
      className: className || classes.root
    }, _react.default.createElement(_.WidgetSearch, _extends({}, search, {
      value: q,
      onChange: onSearch
    })), _react.default.createElement(_.WidgetScroller, {
      className: classes.scroller
    }, _react.default.createElement("div", {
      className: classes.results
    }, _react.default.createElement("p", {
      className: classes.nohits
    }, "Ingen treff"))));
  }

  const placeholder = search.placeholder.replace('{hits}', apps.length);
  return _react.default.createElement("div", {
    className: className || classes.root
  }, _react.default.createElement(_.WidgetSearch, _extends({}, search, {
    placeholder: placeholder,
    value: q,
    onChange: onSearch
  })), _react.default.createElement(_.WidgetScroller, {
    className: classes.scroller
  }, layout === "grid" && _react.default.createElement(_AppsGrid.default, {
    className: classes.results,
    apps: apps,
    onSelect: onSelect
  }), layout === "list" && _react.default.createElement(_AppsList.default, {
    className: classes.results,
    apps: apps,
    onSelect: onSelect
  })));
};

FilterAppsUncontrolled.defaultProps = {
  search: {
    placeholder: "Søk i {hits} applikasjoner"
  }
};
var _default = FilterAppsUncontrolled;
exports.default = _default;
module.exports = exports.default;